import { Action } from '@ngrx/store';
import { UserPreferences } from '@stylehaven/components';

export enum UserPreferencesActionTypes {
    Set = '[UserPreferences] Set',
    Unset = '[UserPreferences] Unset'
}

export class SetUserPreferences implements Action {
    type: UserPreferencesActionTypes.Set = UserPreferencesActionTypes.Set;
    constructor(public payload: UserPreferences) {}
}

export class UnsetUserPreferences implements Action {
    type: UserPreferencesActionTypes.Unset = UserPreferencesActionTypes.Unset;
}

export type UserPreferencesActions = SetUserPreferences | UnsetUserPreferences;
